import { VscListFlat } from "react-icons/vsc";

export const NoDataDetails = () => (
  <div className="vi-glass-card w-full flex flex-col items-center justify-center !h-[400px]">
    <div className="h-12 w-12 bg-[#F0F6FF] rounded-full flex items-center justify-center mb-4">
      <VscListFlat className="text-[#0075E3]" />
    </div>
    <h1 className="text-[16px] font-[500] pb-1 font-inter">
      Select a stock to uncover its financial story
    </h1>
    {/* <p className="font-normal text-sm font-inter !text-center">
      Select one stock to display the financial information here.
    </p> */}
  </div>
);

export const LoadingData = () => {
  return (
    <div className="vi-glass-card flex flex-col items-center justify-center h-96 w-full mt-2 p-2 mb-10">
      <div className="w-8 h-8 border-4 border-[#0075E3] border-t-transparent rounded-full animate-spin mb-4"></div>
      <div className="text-[#101828] font-inter">Generating Financials …</div>
      <div className="text-[#667085] font-inter text-sm">
        This may take a few seconds based on your selected stock
      </div>
    </div>
  );
};
